import type { PickerOption } from '../picker/types';

/** 日期列类型 */
export type DatePickerColumnType = 'year' | 'month' | 'day';

/** 默认列类型配置 */
export const DEFAULT_COLUMNS_TYPE: DatePickerColumnType[] = ['year', 'month', 'day'];

/** DatePicker confirm / cancel 事件参数 */
export interface DatePickerEventParams {
  /** 所有列的选中值 */
  selectedValues: string[];
  /** 所有列的选中选项 */
  selectedOptions: PickerOption[];
  /** 所有列的选中索引 */
  selectedIndexes: number[];
}

/** DatePicker change 事件参数（额外包含列索引） */
export interface DatePickerChangeEventParams extends DatePickerEventParams {
  /** 变化的列索引 */
  columnIndex: number;
}

/** 选项格式化函数 */
export type DatePickerFormatter = (
  type: DatePickerColumnType,
  option: PickerOption,
) => PickerOption;

/** 选项过滤函数 */
export type DatePickerFilter = (
  type: DatePickerColumnType,
  options: PickerOption[],
) => PickerOption[];
